import { motion, useReducedMotion } from "framer-motion";

/** Apparition au scroll (une seule fois), désactivée si l'utilisateur préfère réduire les animations. */
export function Reveal({ children, delay = 0, className = "", testId, y = 24 }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      data-testid={testId}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.div>
  );
}

/** Liste dont les enfants apparaissent en cascade. */
export function Stagger({ children, className = "", testId, step = 0.08 }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      data-testid={testId}
      initial={reduce ? false : "hidden"}
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: step } } }}
    >
      {children}
    </motion.div>
  );
}

export const staggerItem = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

export function StaggerItem({ children, className = "", testId }) {
  return (
    <motion.div className={className} data-testid={testId} variants={staggerItem} whileHover={{ y: -4 }} transition={{ type: "spring", stiffness: 300, damping: 24 }}>
      {children}
    </motion.div>
  );
}
